export enum TenantName {
    BLU_ASIC = 'BLU_ASIC',
    BLU_FCA = 'BLU_FCA',
    BLU_SCB = 'BLU_SCB',
    BLU_SVG = 'BLU_SVG',
    BLU_VFSC = 'BLU_VFSC',
    DNA_ASIC = 'DNA_ASIC',
    DNA_VFSC = 'DNA_VFSC',
    EIG_ASIC = 'EIG_ASIC',
    EIG_CYSEC = 'EIG_CYSEC',
    EIG_FCA = 'EIG_FCA',
    EIG_SCB = 'EIG_SCB',
    EIG_SVG = 'EIG_SVG',
    EIG_VFSC = 'EIG_VFSC',
    FCS_ASIC = 'FCS_ASIC',
    FCS_VFSC = 'FCS_VFSC',
    PAT_ASIC = 'PAT_ASIC',
    PAT_VFSC = 'PAT_VFSC'
}
